// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"6c160e1c","317":"0101071b","318":"7ee6c674","382":"9d605950","430":"e3830dea","442":"aefe531d","570":"30ebe17f","578":"790a26b9","685":"356064fa","739":"790a26b9"}[chunkId] + ".chunk.css";
};